import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { ProviderAvatar } from '../../../components';


export type ProviderInfoCardProps = {
  actions: React.ReactNode;
  provider: {
    id: string;
    first_name: string;
    last_name: string;
    avatar_url?: string;
    preferred_name?: string;
  };
};


const useStyles = makeStyles()(({
  name: {
    fontWeight: 600,
  }
}));


export const ProviderInfoCard: React.FC<ProviderInfoCardProps> = (props) => {
  const l10n = useL10n();
  const { classes } = useStyles();

  const fullName = `${props.provider?.preferred_name || props.provider.first_name} ${props.provider.last_name}`;

  return (
    <Paper square>
      <Box p={2} display="flex">
        <Box>
          <ProviderAvatar src={props.provider.avatar_url} />
        </Box>
        <Box ml={2}>
          <Typography variant="body1" className={classes.name}>{fullName}</Typography>
          <Typography variant="body1">{l10n.resources.appointment.typeByMedicalRole.therapist}</Typography>

          <Box mt={1}>
            {props.children}
          </Box>
        </Box>
      </Box>
      <Box p={2} pt={0}>
        {props.actions}
      </Box>
    </Paper>
  );
};
